import { Component } from 'react'
import cn from 'classnames'

import { Omit } from 'interfaces'
import Paginator, { PaginatorStateProps } from 'components/molecules/tables/Paginator'
import PageSizeSelector, { PageSizeSelectorStateProps } from 'components/atoms/tables/PageSizeSelector'
import { Table2StateProps, TableDispatchProps } from 'components/molecules/tables/Table'
import * as styles from 'components/features/pfm/Pagination/Pagination.css'

type PaginationProps =
  & Omit<Table2StateProps<{}>, 'rows'>
  & {
    pageSize: PageSizeSelectorStateProps
    paginator: PaginatorStateProps
    isMobile: boolean
    paginatorClassName?: string
    paginatorPageClassName?: string
  } & TableDispatchProps

class Pagination extends Component<PaginationProps> {
  render () {
    const { className } = this.props
    return (
      <div className={ cn(styles.pagination, className) } data-qa-marker='pagination'>
        { this.renderPaginator() }
        { this.renderPageSizeSelector() }
      </div>
    )
  }

  renderPaginator () {
    const { paginator, paginatorClassName, onPageClick } = this.props

    if (!paginator || !onPageClick) {
      return null
    }

    return (
      <div className={ styles.paginatorWrapper } data-qa-marker='paginator'>
        <Paginator { ...paginator } className={ paginatorClassName } onPageChange={ onPageClick } />
      </div>
    )
  }

  renderPageSizeSelector () {
    const {
      isMobile,
      paginator,
      pageSize,
      onPageSizeClick,
    } = this.props

    if (isMobile || !pageSize || !onPageSizeClick) {
      return null
    }

    if (paginator.recordsCount <= paginator.pageSize && paginator.pageSize === pageSize.options[0]) {
      return null
    }

    return (
      <div className={ styles.pageSizeSelectorWrapper } data-qa-marker='page-size-selector'>
        <PageSizeSelector { ...pageSize } onPageSizeChange={ onPageSizeClick } />
      </div>
    )
  }
}

export default Pagination
